// Vendor imports
const Cookies = require('js-cookie')
// Client lib imports
const cookieLib = require('client/lib/cookie')

// Action types

const DISMISS = 'LIGHTWEIGHT_ENGAGEMENT_TUTORIAL_DISMISS'

// Action dispatchers

function dismiss() {
  return function (dispatch) {
    dispatch({ type: DISMISS })
    Cookies.remove('ftu_lwe', cookieLib.clearAttributes('ftu_lwe'))
  }
}

// Exports

module.exports = {
  // Action types
  DISMISS,
  // Action dispatchers
  dismiss
}
